/**
 * 下载配置
 * @param xmlContent
 */
export default function downloadMobileConfig(xmlContent) {
  const blob = new Blob([xmlContent], {
    type: "application/x-apple-aspen-config",
  });
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = "config.mobileconfig";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
}

/**
 * @description 获取设备类型
 * @returns {string}  //设备类型
 * @returns 设备类型
 */
export function getDevType() {
  let type = "";
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    //判断iPhone|iPad|iPod|iOS
    type = "ios";
  } else if (/(Android)/i.test(navigator.userAgent)) {
    //判断Android
    type = "android";
  } else {
    type = "pc";
  }
  return type;
}
